// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OK-m","colMin":"styles_colMin__3XzHr"};